import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { __values } from 'tslib';

@Injectable({
    providedIn: 'root'
})



export class CommonService {
    
    year: any;
    curDate: any;
    period: any | number;
    view: any;

    getCurrentFinancialYear(fromDT: any) {
        var fiscalyear = "";
        if(fromDT){
            fromDT = new Date(fromDT).customFormat('#YYYY#-#MM#-#DD#');
        }
        var today = new Date(fromDT);
        if ((today.getMonth() + 1) < 4) {
            fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
        } else {
            fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
        }
        return fiscalyear
    }
  
    checkFinancialYear(date1: any, date2: any) {
        let financialYear = [];
        let checkBrowser = 0; //0 - chrome , 1- other browser
        let fYear = new Date(date1).getFullYear();
        let lYear = new Date(date2).getFullYear();
        let toValueCheck = lYear;
        if (fYear == lYear) {
            let fMonth = new Date(date1).getMonth() + 1;
            if (fMonth < 4) {
                fYear = fYear - 1;
            }
            else {
                fYear = fYear;
            }
            let lMnth = new Date(date2).getMonth() + 1;
            if (lMnth > 3) {
                toValueCheck = lYear + 1;
            }
            
        }
        else {
            let fMonth = new Date(date1).getMonth() + 1;
            if (fMonth < 4) {
                fYear = fYear - 1;
            }
            else {
                fYear = fYear;
            }
    
            let lMnth = new Date(date2).getMonth() + 1;
            if (lMnth > 3) {
                toValueCheck = lYear + 1;
            }
        }
    
        if (navigator.userAgent.indexOf("Firefox") > -1) {
            //firefox
            checkBrowser = 1;
        }
        for (var i = fYear; i < toValueCheck; i++) {
            let ndate = "";
            ndate = checkBrowser ?  '01 Apr '+i : '1-Apr-' + i;
            financialYear.push({ 'FY': this.getCurrentFinancialYear(ndate) })
        }
        return financialYear;
    }
    
    GetParam(name: any){
        const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if(!results){
          return 0;
        }
        return results[1] || 0;
    }

    //PrecisionwiseValue() - Precisionwise number get
    PrecisionwiseValue (textValue : any, precisions: any, isAllowPoint? : any) {
        var re = /[^\d.]/g;
        if (re.test(textValue)) {
            return "";
        }
        if (precisions == 0) {
            var splitvalue = textValue.split('.');
            return splitvalue[0];
        }
        var val = textValue;
        if (val === undefined) {
            var val: any = '';
        }
        var clean = val.replace(/[^-0-9\.]/g, '');
        var negativeCheck = clean.split('-');
        var decimalCheck = clean.split('.');
        // if (!angular.isUndefined(negativeCheck[1])) {
            if (negativeCheck[1] != undefined) {
            negativeCheck[1] = negativeCheck[1].slice(0, negativeCheck[1].length);
            clean = negativeCheck[0] + '-' + negativeCheck[1];
            if (negativeCheck[0].length > 0) {
                clean = negativeCheck[0];
            }
        }
        // if (!angular.isUndefined(decimalCheck[1])) {
        if (decimalCheck[1] != undefined) {
            decimalCheck[1] = decimalCheck[1].slice(0, precisions);
            clean = decimalCheck[0] + '.' + decimalCheck[1];
        }
        else if(isAllowPoint == true) {
            clean = Number(clean).toFixed(precisions);
        }
        return clean;
    };

    //number Only
    numberOnly(event: any): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57 ) && charCode != 46) {
            return false;
        }
        return true;
    }

    getMonthYear(startDate: any, endDate: any){
        startDate = new Date(new Date(startDate).customFormat('#YYYY#-#MM#-#DD#'));
        endDate =  new Date(new Date(new Date(endDate).setMonth(new Date(endDate).getMonth())).customFormat('#YYYY#-#MM#-#DD#'));
        // endDate = new Date(new Date(endDate).customFormat('#YYYY#-#MM#-#DD#'));
        var dates = [];

        var month = new Date(startDate);
        let id = 0;
        while (month <= endDate) {
            id++;
            dates.push({
                number: month.customFormat('#MM#'),
                year: month.customFormat('#YYYY#'),
                display: month.customFormat('#MMM# #YYYY#'),
                id: id,
                month: month.customFormat('#MMMM#')
            });  
            month = new Date(new Date(month).setMonth(new Date(month).getMonth() + 1));          
        }
        return dates;
    }


    checkforMenuRights(userID: number, module: string, rightsName: string): any{
        let isAdmin: boolean = false;
        let tblM: any = localStorage.getItem("M");
        if(tblM){
            tblM = JSON.parse(tblM);
        }


        let tblJ: any = localStorage.getItem("J");
        if(tblJ){
            tblJ = JSON.parse(tblJ);
        }

        if(tblM.length > 0 && tblJ.length > 0){
            if(tblM[0].AdminUserID == userID){
                return true;
            }
            else{
                let ownRights: any = $.grep(tblJ, function(o: any){ return o.UserID == userID})[0];
             switch (module){
                 case "ACCT" :
                    if(rightsName == "ALL"){
                        if(ownRights.Accts && ownRights.AcctsVchrEntry && ownRights.AcctsCfg){
                            return true;
                        }
                        else{
                            return false;
                        }
                    }
                    else{
                        return false;
                    }
                 case "CRM" :
                     if(rightsName == "ALL"){

                     }
                    return "";
                 case "B2B": 
                    return "";
             }

            }
        }
        else{
            return false;
        }
    }

    checkLogin(){
        var jarvis = localStorage.getItem("Jarvis");
        if (jarvis == 'undefined' || jarvis == undefined || jarvis == null) {
            alert("Invalid Access.");
            window.location.href = '../../main.html#/home';
            return false;
          }
         return true;
    }

    //encryptData() - Encrypt or Decrypt String
    encryptData(s: any){
        let enc: string = "";
        var str: string = "";
        var k: any = "123";
        // make sure that input is string
        str = s.toString();
        for (let i: number = 0; i < str.length; i++) {
            // create block
            let a: number = str.charCodeAt(i);

            // bitwise XOR
            let b: number = a ^ k;
            enc = enc + String.fromCharCode(b);
        }
        return enc;
    }

    checkRenewal() {
        var today: any = new Date();
        today = today.setHours(0, 0, 0, 0);
        today = new Date(today);
        let tblM: any = localStorage.getItem("M");
        if(tblM){
            tblM = JSON.parse(tblM);
            //let startRenewalShowDT = new Date(tblM.PremiumTillDT).addDays(-21);
                if (tblM[0].SubscriptionTypeID == 3 && (new Date(tblM[0].PremiumTillDT) < new Date(today))) {
                    return true;
                }
                else {
                    return false;
                }
        } 
        else{
            return false
        } 
        
    } 

    //Get M Cookie
    getMTable() {
        let agencyData: any = localStorage.getItem("M");
        return JSON.parse(agencyData);
    }

    //checkShowLearningMaterial() - Show/Hide the Learning Material
    checkShowLearningMaterial() {
        let agencyData: any = this.getMTable();
        if (agencyData.length > 0) {
            if (agencyData[0].SubUpgradedDT) {
                let subUpgradedDT = new Date(agencyData[0].SubUpgradedDT);
                subUpgradedDT.setDate(subUpgradedDT.getDate() + 30);
                let dateEndTraingMaterials = new Date(subUpgradedDT.toISOString().substr(0, 10));
                if (dateEndTraingMaterials >= new Date()) {
                    return true;
                }
            }
        }
        return false;
    }

    //openModulHelp - Open help page 
    openModulHelp(id: any, isWeb: any) {
        if (id) {
            if (isWeb) {
                window.open("https://biziverse.com/Html/External/RequestSupport.html?v=1.2&id=" + id, '_blank', 'height = 470, width = 900');
            } else {
                window.open("https://biziverse.com/Html/External/RequestSupport.html?v=1.2&id=" + id, '_self');
            }
        }
        else {
            if (isWeb) {
                window.open("https://biziverse.com/Html/External/RequestSupport.html?v=1.2", '_blank', 'height = 470, width = 900');
            } else {
                window.open("https://biziverse.com/Html/External/RequestSupport.html?v=1.2", '_self');
            }
        }        
    }

    //addDays Function
    addDays(date: Date, days: number): Date {
        let result = new Date(date);
        result.setDate(date.getDate() + days);
        return result;
    }

    //Check first week subscription
    checkShowOnBoarding() {
        let agencyData: any = this.getMTable();
        if (agencyData.length > 0) {
            if (agencyData[0].FirstUpgdDT) {
                if (this.addDays(new Date(agencyData[0].FirstUpgdDT), 7) > new Date()) {
                    return true;
                }
            }
        }
        return false;
    }

    getDateRange(period: string, otherMonth: number = 0, otherYear: number = 0, fyValue: string = ''): any {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let startDate: Date = new Date();
        let endDate: Date = new Date();

        switch (period) {
            case "This Month":
                startDate = new Date(today.getFullYear(), today.getMonth(), 1);
                endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;

            case "Last Month":
                startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                endDate = new Date(today.getFullYear(), today.getMonth(), 0);
                break;

            case "This Quarter": {
                const currentQuarter = Math.floor(today.getMonth() / 3);
                startDate = new Date(today.getFullYear(), currentQuarter * 3, 1);
                endDate = new Date(today.getFullYear(), (currentQuarter + 1) * 3, 0);
                break;
            }

            case "Prev Quarter": {
                const prevQuarter = Math.floor(today.getMonth() / 3) - 1;
                const year = prevQuarter < 0 ? today.getFullYear() - 1 : today.getFullYear();
                const quarter = prevQuarter < 0 ? 3 : prevQuarter;

                startDate = new Date(year, quarter * 3, 1);
                endDate = new Date(year, (quarter + 1) * 3, 0);
                break;
            }

            case "Fin Year":
                if (fyValue && fyValue.includes('-')) {
                    const [start, end] = fyValue.split('-');
                    const startYear = parseInt(start, 10);
                    const endYear = parseInt(end, 10);

                    startDate = new Date(startYear, 3, 1); // April 1
                    endDate = new Date(endYear, 2, 31);   // March 31
                } else {
                    const finYearStart =
                        today.getMonth() >= 3
                            ? today.getFullYear()
                            : today.getFullYear() - 1;

                    startDate = new Date(finYearStart, 3, 1);
                    endDate = new Date(finYearStart + 1, 2, 31);
                }
                break;

            case "Other Month":
                if (otherMonth && otherYear) {
                    const monthIndex = Number(otherMonth) - 1;
                    const year = Number(otherYear);

                    startDate = new Date(year, monthIndex, 1);
                    endDate = new Date(year, monthIndex + 1, 0);
                }
                break;

            default:
                startDate = new Date(today);
                endDate = new Date(today);
        }

        if (endDate > today) {
            endDate = new Date(today);
        }

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);

        return {
            startDate,
            endDate,
        };
    }
}
